export default "__VITE_ASSET__fbe4d6f5__"